<template>
  <div>
    <div class="container-fluid selfie" v-if="step !== 'CAPTURA'">
      <div class="container">
        <div class="row">
          <div class="col-lg-4 col-10 col-sm-8 mx-auto selfie-form">
            <router-link to="/" class="content-logo-principal">
             <div style="display:flex;justify-content:center;align-items:center">
                <h1 >
                  <a href="https://royalpag.com">
                         <img :src="img" style="width: 250px">
                  </a>
                </h1>
              </div>
            </router-link>
            <div v-if="step === 'START'">
              <h2 class="text-center text-default-gray logo_h2 msg-title">
                Agora precisamos de uma selfie sua, fique atento às instruções:
              </h2>
              <ul style="list-style: inside; margin-bottom: 20px;font-family: Roboto; font-size: 14px;">
                <li>Retire óculos e chapéu.</li>
                <li>Enquadre seu rosto na área demarcada.</li>
                <li>Esteja em um local iluminado.</li>
              </ul>
              <p class="text-center text-default-gray msg-sub-title">
                Não se preocupe,
                <strong>essa foto não será divulgada</strong>
              </p>
              <div class="card-body pt-0">
                <button type="reset" @click.prevent="startCapture()" class="btn btn-primary btn-block btn-start mb-3">
                  <i class="fa fa-camera fa-2x float-left pr-2"></i>
                  <div class="btn-start-align">Iniciar captura</div>
                </button>
              </div>
              <p class="text-center text-default-gray msg-sub-title">
                Ou complete seu cadastro utilizando as opções:
              </p>
              <button type="reset" @click.prevent="sendSMS()" class="btn btn-primary btn-block btn-start mb-3" style="margin-top: 0px;">
                <i class="fa fa-envelope fa-2x float-left pr-2"></i>
                <div class="btn-start-align">Enviar SMS</div>
              </button>
              <button type="reset" @click.prevent="scanQRCode()" class="btn btn-primary btn-block btn-start mb-3" style="margin-top: 0px;">
                <i class="fa fa-qrcode fa-2x float-left pr-2"></i>
                <div class="btn-start-align">Escanear QR Code</div>
              </button>
            </div>
            <div v-if="step === 'ERRO_FOTO'">
              <h2
                class="text-center text-default-gray logo_h2 msg-title"
              >{{ errorMessage ? errorMessage : 'Não foi possível processar a sua selfie, por favor tente novamente'}}</h2>
              <div class="card-body pt-0">
                <button type="reset" @click.prevent="restartCapture()" class="btn btn-primary btn-block btn-start mb-3">
                  <i class="fa fa-camera fa-2x float-left pr-2"></i>
                  <div class="btn-start-align">Reiniciar captura</div>
                </button>
                <div class="card-body pt-0" style="margin-top: 20px;">
                  <span style="font-family: Roboto; font-size: 14px;">
                    Está com dificuldade na captura? Temos outras opções, <strong><span @click.prevent="otherOptions()" style="cursor: pointer;">clique aqui!</span></strong>
                  </span>
                </div>
              </div>
            </div>
            <div v-if="step === 'ERRO_CAMERA' || step === 'OUTRAS_OPCOES' || step === 'OUTRAS_OPCOES_LIMITE_TENTATIVAS' || step === 'ERRO_SMS' || step === 'ERRO_QRCODE'">
              <h2 v-if="step === 'ERRO_CAMERA'" class="text-center text-default-gray logo_h2 msg-title">
                Infelizmente não conseguimos abrir sua câmera, mas você pode completar seu cadastro utilizando as opções abaixo
              </h2>
              <h2 v-if="step === 'OUTRAS_OPCOES'" class="text-center text-default-gray logo_h2 msg-title">
                Você pode completar seu cadastro utilizando as opções abaixo
              </h2>
              <h2 v-if="step === 'OUTRAS_OPCOES_LIMITE_TENTATIVAS'" class="text-center text-default-gray logo_h2 msg-title">
                Não conseguimos processar a sua selfie, no entanto você pode completar seu cadastro <strong>utilizando as opções abaixo:</strong>
              </h2>
              <h2 v-if="step === 'ERRO_SMS'" class="text-center text-default-gray logo_h2 msg-title">
                Não conseguimos enviar o SMS para seu celular, tente novamente em alguns instantes
              </h2>
              <h2 v-if="step === 'ERRO_QRCODE'" class="text-center text-default-gray logo_h2 msg-title">
                Não conseguimos gerar o código QR Code, tente novamente em alguns instantes
              </h2>
              <div class="card-body pt-0">
                <button type="reset" @click.prevent="sendSMS()" class="btn btn-primary btn-block btn-start mb-3">
                  <i class="fa fa-envelope fa-2x float-left pr-2"></i>
                  <div class="btn-start-align">Enviar SMS</div>
                </button>
                <button type="reset" @click.prevent="scanQRCode()" class="btn btn-primary btn-block btn-start mb-3">
                  <i class="fa fa-qrcode fa-2x float-left pr-2"></i>
                  <div class="btn-start-align">Escanear QR Code</div>
                </button>
                <button v-if="cameraDenied" type="reset" @click.prevent="startCapture()" class="btn btn-primary btn-block btn-start mb-3">
                  <i class="fa fa-camera fa-2x float-left pr-2"></i>
                  <div class="btn-start-align">Reiniciar captura</div>
                </button>
                <button type="reset" @click.prevent="backToHome()" class="btn btn-primary btn-block btn-start mb-3">
                  <i class="fa fa-arrow-left fa-2x float-left pr-2"></i>
                  <div class="btn-start-align">Voltar</div>
                </button>
              </div>
            </div>
            <div v-if="step === 'FINALIZADO'">
              <h2
                class="text-center text-default-gray logo_h2 pb-5"
                style="font-size: 16px; font-family: Roboto;"
              >Sua conta foi criada e já pode ser utilizada através do botão abaixo, muito obrigado!</h2>
              <div class="form-group">
                <input
                  type="reset"
                  @click.prevent="entrar"
                  value="Entrar"
                  :style="color"
                  class="btn btn-primary btn-block btn-normal"
                />
              </div>
            </div>
            <div v-if="step === 'ENVIANDO_SMS'">
              <h2 class="text-center text-default-gray logo_h2 pb-5" style="font-size: 16px; font-family: Roboto;">
                Enviando SMS para seu número de cadastro, aguarde ...
              </h2>
            </div>
            <div v-if="step === 'FINALIZADO_SMS'">
              <h2
                class="text-center text-default-gray logo_h2 pb-5"
                style="font-size: 16px; font-family: Roboto;"
              >Você receberá um SMS com o link para completar seu cadastro, muito obrigado!</h2>
              <div class="form-group">
                <input
                  type="reset"
                  @click.prevent="entrar"
                  value="Entrar"
                  :style="color"
                  class="btn btn-primary btn-block btn-normal"
                />
                <input
                  type="reset"
                  @click.prevent="backToHome"
                  value="Voltar"
                  class="btn btn-primary btn-block btn-normal"
                />
              </div>
            </div>
            <div v-if="step === 'GERANDO_QRCODE'">
              <h2 class="text-center text-default-gray logo_h2 pb-5" style="font-size: 16px; font-family: Roboto;">
                Gerando QR Code, aguarde ...
              </h2>
            </div>
            <div v-if="step === 'FINALIZADO_QRCODE'">
              <h2
                class="text-center text-default-gray logo_h2 pb-5"
                style="font-size: 16px; font-family: Roboto;"
              >Para escanear o código QR utilize a câmera do seu celular e abra o link que será exibido, muito obrigado!</h2>
              <div class="form-group">
                <img :src="qrcode" style="display: block; margin: 0 auto 30px auto; width: 180px;" />
              </div>
              <div class="form-group">
                <input
                  type="reset"
                  @click.prevent="entrar"
                  value="Entrar"
                  :style="color"
                  class="btn btn-primary btn-block btn-normal"
                />
                <input
                  type="reset"
                  @click.prevent="backToHome"
                  value="Voltar"
                  class="btn btn-primary btn-block btn-normal"
                />
              </div>
            </div>
            <div v-if="step === 'FOTO_VERIFICADA'">
              <h2
                class="text-center text-default-gray logo_h2 pb-5"
                style="font-size: 16px; font-family: Roboto;"
              >Você já realizou o processo de verificação da foto, muito obrigado!</h2>
              <div class="form-group">
                <input
                  type="reset"
                  @click.prevent="entrar"
                  value="Entrar"
                  :style="color"
                  class="btn btn-primary btn-block btn-normal"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="step === 'CAPTURA'">
      <the-camera-selfie/>
    </div>
  </div>
</template>

<script>
  import localforage from 'localforage'
  import TheCameraSelfie from '@/components/camera'
  import { mapActions, mapGetters } from 'vuex'
  import VueToast from 'vue-toastr-2/src/toastr.min'
  import site_style from '@/service/site_style'

  export default {
    name: 'Selfie',
    components: {
      TheCameraSelfie
    },
    data () {
      return {
        img: site_style.getLogo().default,
        color: site_style.getColor(),
        selfieData: {
          sessionId: '',
          token: '',
          base64: '',
          deviceInfo: '',
          type: 'SELFIE'
        },
        qrcode: '',
        step: 'START',
        cameraDenied: false,
        errorMessage: '',
        attemptsReached: false
      }
    },
    computed: {
      ...mapGetters(['getIt'])
    },
    mounted () {
      let _self = this
      // CAPTURE --------
      this.$bus.$on('capturedImage', async (response) => {
        _self.selfieData.base64 = response.base64
        _self.selfieData.deviceInfo = JSON.stringify(response.deviceInfo)
        await _self.process()
      })
      // CAMERA OPENED --------
      this.$bus.$on('cameraOpened', response => {
        console.log('câmera aberta com sucesso')
      })
      // CAMERA ERROR --------
      this.$bus.$on('cameraError', async (response) => {
        // câmera desabilitada
        if (response && response.message && response.message.indexOf('Permission denied') > 0) {
          _self.cameraDenied = true
        }
        _self.step = 'ERRO_CAMERA'
        _self.selfieData.deviceInfo = JSON.stringify(response.deviceInfo)
        _self.selfieData.sessionId = 'I-INA-SYSTEM'
        _self.selfieData.token = await localforage.getItem('I-INA-SYSTEM')
        const verb = 'post'
        const { selfieData } = this
        // envia o log para o servidor
        try {
          await _self.checkSelfie({ verb, selfieData }).then((selfieResponse) => {
            if (selfieResponse && selfieResponse.usuario && selfieResponse.usuario.fotoVerificada) {
              _self.step = 'FOTO_VERIFICADA'
            } else {
              if (_self.cameraDenied) {
                this.showToast({verb: 'error', message: 'Por favor habilite a sua câmera', title: 'Câmera bloqueada', options: null})
              }
            }
            console.log('log enviado para o servidor')
          }).catch((error) => {
            if (error) {
              console.log('erro:', error)
            }
            _self.step = 'ERRO_CAMERA'
          })
        } catch (error) {
          if (error) {
            console.log('erro:', error)
          }
          _self.step = 'ERRO_CAMERA'
        }
      })
    },
    updated () {
      let a2hsContainer = document.querySelector('#addToHomeContainer')
      if (a2hsContainer) {
        setTimeout(() => {
          a2hsContainer.style.display = 'none'
        }, 300)
      }
    },
    methods: {
      ...mapActions('usuarios', ['checkSelfie']),
      entrar () {
        this.$router.push({ name: 'auth.index' })
      },
      startCapture () {
        this.qrcode = ''
        this.selfieData.deviceInfo = ''
        this.selfieData.type = 'SELFIE'
        this.step = 'CAPTURA'
      },
      restartCapture () {
        this.qrcode = ''
        this.selfieData.deviceInfo = ''
        this.selfieData.type = 'SELFIE'
        this.step = 'CAPTURA'
      },
      otherOptions () {
        this.step = 'OUTRAS_OPCOES'
      },
      backOptions () {
        this.step = 'OUTRAS_OPCOES'
      },
      backToHome () {
        this.step = 'START'
      },
      async sendSMS () {
        this.step = 'ENVIANDO_SMS'
        this.selfieData.type = 'SMS'
        await this.process()
      },
      async scanQRCode () {
        this.step = 'GERANDO_QRCODE'
        this.selfieData.type = 'QRCODE'
        await this.process()
      },
      // PROCESS IMAGE
      async process () {
        this.selfieData.sessionId = 'I-INA-SYSTEM'
        this.selfieData.token = await localforage.getItem('I-INA-SYSTEM')
        const verb = 'post'
        const { selfieData } = this
        let _self = this
        try {
          await this.checkSelfie({ verb, selfieData }).then(response => {
            // error
            if (!response || response.error) {
              let beforeStep = _self.step
              _self.step = 'ERRO_FOTO'
              if (response) {
                if (response.message) {
                  _self.errorMessage = response.message
                } else {
                  _self.errorMessage = ''
                }
                if (response.attemptsReached) {
                  _self.step = 'OUTRAS_OPCOES_LIMITE_TENTATIVAS'
                } else if (beforeStep === 'ENVIANDO_SMS') {
                  _self.step = 'ERRO_SMS'
                } else if (beforeStep === 'GERANDO_QRCODE') {
                  _self.step = 'ERRO_QRCODE'
                }
                _self.attemptsReached = response.attemptsReached
              }
            } else {
              // success
              if (_self.step === 'ENVIANDO_SMS') {
                _self.step = 'FINALIZADO_SMS'
              } else if (_self.step === 'GERANDO_QRCODE') {
                _self.step = 'FINALIZADO_QRCODE'
                _self.qrcode = response.qrcode
              } else {
                _self.step = 'FINALIZADO'
              }
              this.$bus.$emit('stopCameraProcess', null)
            }
          }).catch((error) => {
            console.error('erro:', error)
            this.$bus.$emit('stopCameraProcess', null)
            _self.step = 'ERRO'
            _self.errorMessage = ''
          })
        } catch (error) {
          console.error('erro:', error)
        }
      },
      showToast (obj) {
        const toast = VueToast
        const verb = obj.verb
        const message = obj.message
        const title = obj.title
        const options = obj.options
        this.$store.dispatch('toast', {verb, message, title, options, toast})
      }
    }
  }
</script>

<style src="../../assets/css/selfie.scss" scoped></style>
<style scoped>
.btn-normal {
  height: 35px;
  margin: 10px 0;
}
</style>



// WEBPACK FOOTER //
// selfie.vue?784da924